module.exports = __webpack_public_path__ + "img/ec362cf90858f0f430e7ed3e75defb9.9ac04621.png";